import { Type } from 'typebox';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const ActivityGoal = Type.Object({
    id: Type.String({ minLength: 1 }),
    linktype: Type.Optional(Type.String({ minLength: 1 })),
    rating: Type.Optional(Type.Integer())
});
export const ActivityEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.activity),
        name: Type.Optional(Type.String()),
        activities: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        unmodifiedActivities: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        goals: Type.Optional(Type.String()),
        cDomains: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        cGoals: Type.Optional(Type.Array(ActivityGoal)),
        cGoalLabels: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        materials: Type.Optional(Type.String()),
        instructions: Type.Optional(Type.String()),
        options: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        members: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        source: Type.Optional(Type.String()),
        sortOrder: Type.Optional(Type.Integer()),
        tsgType: Type.Optional(Type.String({ minLength: 1 })),
        tsgId: Type.Optional(Type.Integer()),
        lessonPlanOnly: Type.Optional(Type.Boolean())
    })
]));
